import projectLogo from "assets/img/auth/omni-sport-logo.png";

type BrandLogoSize = "sm" | "md" | "lg";

interface BrandLogoProps {
  size?: BrandLogoSize;
  showWordmark?: boolean;
  align?: "left" | "center";
  className?: string;
}

const SIZE_CLASS: Record<BrandLogoSize, { shell: string; image: string; title: string; subtitle: string }> = {
  sm: {
    shell: "h-10 w-10 rounded-xl p-1.5",
    image: "h-7 w-7",
    title: "text-sm",
    subtitle: "text-[10px]",
  },
  md: {
    shell: "h-12 w-12 rounded-2xl p-2",
    image: "h-8 w-8",
    title: "text-base",
    subtitle: "text-[11px]",
  },
  lg: {
    shell: "h-28 w-28 rounded-[28px] p-3",
    image: "h-20 w-20",
    title: "text-[30px]",
    subtitle: "text-sm",
  },
};

const BrandLogo = ({
  size = "md",
  showWordmark = true,
  align = "left",
  className = "",
}: BrandLogoProps): JSX.Element => {
  const sizeClass = SIZE_CLASS[size];
  const alignment = align === "center" ? "justify-center text-center" : "justify-start text-left";

  return (
    <div className={`flex items-center gap-3 ${alignment} ${className}`.trim()}>
      <div className={`flex items-center justify-center border border-line bg-surface shadow-lg shadow-shadow-500 ${sizeClass.shell}`}>
        <img src={projectLogo} alt="OmniSport" className={`${sizeClass.image} object-contain`} />
      </div>
      {showWordmark ? (
        <div>
          <p className={`font-poppins font-bold uppercase leading-none tracking-[0.18em] text-brand-500 ${sizeClass.title}`}>
            OmniSport
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default BrandLogo;